import React, { useEffect } from "react";
import {
  IonButton,
  IonContent,
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonLoading,
} from "@ionic/react";
import { setActiveHouseVisit, setChangedFormItems } from "../visit/visitSlice";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { loadRecord, loadPlan, loadPersonalFile, reset } from "./patientSlice";
import { getFullName } from "../../components/util/helpers";
import Personal from "./cards/Personal";
import Emergency from "./cards/Emergency";
import Communications from "./cards/Communications";
import Relatives from "./cards/Relatives";
import Notes from "./cards/Notes";
import Hospitalizations from "./cards/Hospitalizations";
import Scheduling from "./cards/Scheduling";
import FileUpload from "./cards/FileUpload";
import Visits from "./cards/Visits";
import Address from "./cards/Address";
import moment from "moment";

const PatientCard = (props) => {
  const { onHide, patientId, branchId, type } = props;
  const intl = useIntl();
  const dispatch = useDispatch();
  const activePatient = useSelector((state) => state.patient.activePatient);
  const activePlan = useSelector((state) => state.patient.activePlan);
  const { personalFile: personalFilePage } = useSelector(
    (state) => state.patient
  );
  const employeeId = useSelector(
    (state) => state.auth.profile.associated_employee_id
  );
  const loading = useSelector(
    (state) => state.pendingActions["patient/addAsset"]
  );

  const loadingPatient = useSelector(
    (state) => state.pendingActions["patient/loadPatient"]
  );

  const { items } = personalFilePage;

  useEffect(() => {
    if (patientId && branchId && !activePatient.id) {
      const params = {
        id: patientId,
        branchId: branchId,
        admin: false,
        patientId: patientId,
      };
      dispatch(loadRecord(params));
      dispatch(loadPlan(params));
      dispatch(loadPersonalFile({ patientId }));
    }

    return function cleanup() {
      dispatch(reset());
    };
  }, [patientId, branchId, dispatch]);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>
            {activePatient &&
              getFullName(activePatient.surename, activePatient.first_name)}
          </IonTitle>
          <IonButtons slot="start">
            {type === "fromPatient" ? (
              <IonBackButton
                defaultHref="/app/patients"
                text={intl.formatMessage({
                  id: `app.mobile.titles.patients`,
                })}
              />
            ) : (
              <IonButton onClick={onHide} size="default">
                {intl.formatMessage({
                  id: `app.mobile.actions.close`,
                })}
              </IonButton>
            )}
          </IonButtons>
          {type === "fromPatient" && (
            <IonButtons slot="end">
              <IonButton
                routerLink={`/app/patients/${activePatient.branch}/${activePatient.id}/newvisit`}
                onClick={() => {
                  dispatch(
                    setActiveHouseVisit({
                      record: {
                        patient: activePatient,
                        id: 10000000,
                        planned_employee_id: employeeId,
                        date: moment().startOf("day").add(12, "hours").format(),
                      },
                    })
                  );

                  dispatch(
                    setChangedFormItems({
                      changed: ["planned_employee_id", "date"],
                      values: {
                        planned_employee_id: employeeId,
                        date: moment().startOf("day").add(12, "hours").format(),
                      },
                    })
                  );
                }}
                size="default"
              >
                {intl.formatMessage({
                  id: `app.mobile.new_visit`,
                })}
              </IonButton>
            </IonButtons>
          )}
        </IonToolbar>
      </IonHeader>
      <IonContent>
        {loadingPatient ? (
          <IonLoading isOpen={true} />
        ) : (
          <Personal activePatient={activePatient} />
        )}
        {loadingPatient ? (
          <IonLoading isOpen={true} />
        ) : (
          <Communications activePatient={activePatient} />
        )}

        {loadingPatient ? (
          <IonLoading isOpen={true} />
        ) : (
          <Address activePatient={activePatient} />
        )}

        {loadingPatient ? (
          <IonLoading isOpen={true} />
        ) : (
          <Relatives activePatient={activePatient} />
        )}
        {loadingPatient ? (
          <IonLoading isOpen={true} />
        ) : (
          activePatient?.emergency?.has_emergency_details && (
            <Emergency activePatient={activePatient} />
          )
        )}

        <Notes items={items} />
        <Hospitalizations activePatient={activePatient} />
        <Scheduling activePlan={activePlan} />
        <Visits
          activePatient={activePatient}
          patientId={patientId}
          branchId={branchId}
        />

        <FileUpload activePatient={activePatient} />
      </IonContent>
      {loading && (
        <IonLoading
          isOpen={true}
          message={intl.formatMessage({
            id: "app.mobile.alert.uploading_file",
          })}
        />
      )}
    </IonPage>
  );
};

export default PatientCard;
